import request from "../utils/request";

// shop/page

export function CommodityPage(data) {
  return request({
    url: '/shop/page',
    method: 'post',
    data: data
  })
}

// shop/add
export function addCommodity(data) {
  return request({
    url: '/shop/add',
    method: 'post',
    data: data
  })
}

// shop/delete
export function deleteCommodity(data) {
  return request({
    url: '/shop/delete',
    method: 'post',
    params: data
  })
}

// shop/order/create
export function createCommodity(data) {
  return request({
    url: '/shop/order/create',
    method: 'post',
    data: data
  })
}

// shop/top
export function topCommodity(data) {
  return request({
    url: '/shop/top',
    method: 'get',
    params: data
  })
}

// shop/order/page
export function orderPage(data) {
  return request({
    url: '/shop/order/page',
    method: 'post',
    data: data
  })
}

// shop/tax/info
export function getTaxInfo() {
  return request({
    url: '/shop/tax/info',
    method: 'get',
  })
}

// shop/order/remove
export function removeOrder(data) {
  return request({
    url: '/shop/order/remove',
    method: 'get',
    params: data
  })
}